import { useAuthStore } from '@/stores/auth'
import axios from 'axios'
import type { ISystemError, ISystemErrorData } from '@/models/error'
import { SystemError } from '@/models/error'
import { FieldErrors } from '@/models/error'

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_URL,
})

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // TODO: LF-2025-02-08 - Take token from auth store
    // Attempted to do this but causes a circular dependency
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function httpErrorHandler(error: any): ISystemError {
  const systemErrorData: ISystemErrorData = {
    name: error.name,
    message: error.message
  }

  if (axios.isAxiosError(error)) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      systemErrorData.message = error.response.statusText
      systemErrorData.statusCode = error.response.status
      if (error.response.data.detail) {
        systemErrorData.detail = error.response.data.detail
      } else if (FieldErrors.isFieldError(error.response.data)) {
        systemErrorData.fieldErrors = new FieldErrors(error.response.data)
      }
    } else if (error.request) {
      // The request was made but no response was received (Can happen on 500 error)
      systemErrorData.detail =
        'There was an error in processing your request. Please check with IT Admin'
    }
  }

  return new SystemError(systemErrorData)
}

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const authStore = useAuthStore()
      await authStore.logout()
    }
    return Promise.reject(httpErrorHandler(error))
  }
)

export default axiosInstance 